import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';  // Importa el locale español de Ant Design
import dayjs from 'dayjs';  // Importa Day.js
import 'dayjs/locale/es';  // Importa el locale en español para Day.js
import localizedFormat from 'dayjs/plugin/localizedFormat';  // Importa plugin para formatos localizados
import * as Sentry from "@sentry/react";

dayjs.extend(localizedFormat);  // Extiende Day.js con los formatos localizados
dayjs.locale('es');  // Establece Day.js para que use el locale en español


Sentry.init({
  dsn: "https://5d83554d57e4a6bca2f076fd949d79be@o4508962149040128.ingest.us.sentry.io/4509193292021760",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    "localhost:5007",       // para desarrollo local
    "zafpan.online",           // dominio de producción
    "api",                  // opcional: rutas que contengan "api"
  ]

});



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={esES}>  {/* Aplica el locale español de Ant Design */}
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

reportWebVitals();
